/* © 2014 - Copyright of Aetonix Systems Inc - All Rights Reserved. Patent pending.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Aetonix, June 19, 2014
 * For information or permission request, email info@aetonixsystems.com
 */



var Model = require("../types/Model.js");
var ReactNative = require("react-native");
const AsyncStorage = require("@react-native-async-storage/async-storage").default;
var Platform = ReactNative.Platform;
var AppState = ReactNative.AppState;
var NativeModules = ReactNative.NativeModules;
var ShortcutBadger = NativeModules.ShortcutBadger;
var BackgroundCheckModule = require("react-native-background-check");

const {Notifications} = require("react-native-notifications");

module.exports = new Model({
	name: "remotepushhandler",
	init: init,
	uninit: uninit,
	listeners: listeners,
	triggers: triggers,

	_callState: null,
	_callNotification: undefined,
	handleTokenSuccess: handleTokenSuccess,
	handlePayload: handlePayload,
	clear: clear
});

function init() {
	this.emit("logout:trigger:setup", {
		type: "notifications"
	});
	this.emit("refresh:trigger:setup", {
		type: "notifications"
	});
	this._callNotification = {};
	this._onNotificationReceivedForeground = notificationReceivedForeground.bind(this);
	this._onNotificationReceivedBackground = notificationReceivedBackground.bind(this);
	this._onNotificationOpened = onNotificationOpened.bind(this);
	this._onNotificationRegistered = onRemoteNotificationsRegistered.bind(this);
	this._onRegistrationFailed = handleError.bind(this);

	this._foregroundEvent = Notifications.events().registerNotificationReceivedForeground(this._onNotificationReceivedForeground);
	this._backgroundEvent = Notifications.events().registerNotificationReceivedBackground(this._onNotificationReceivedBackground);
	this._openedEvent = Notifications.events().registerNotificationOpened(this._onNotificationOpened);
	this._registeredEvent = Notifications.events().registerRemoteNotificationsRegistered(this._onNotificationRegistered);
	this._failedEvent = Notifications.events().registerRemoteNotificationsRegistrationFailed(this._onRegistrationFailed);
	Notifications.getInitialNotification().then(handleInitialNotification.bind(this));
	Notifications.registerRemoteNotifications();
}

function uninit() {
	this._callNotification = null;
	if(this._foregroundEvent && this._foregroundEvent.remove) this._foregroundEvent.remove();
	if(this._backgroundEvent && this._backgroundEvent.remove) this._backgroundEvent.remove();
	if(this._openedEvent && this._openedEvent.remove) this._openedEvent.remove();
	if(this._registeredEvent && this._registeredEvent.remove) this._registeredEvent.remove();
	if(this._failedEvent && this._failedEvent.remove) this._failedEvent.remove();
}

function listeners() {
	return {
		"app:focus": clearBadge,
		"calling:update": setCallState
	};
}

function triggers(){
	return {
		"refresh": handleRefresh,
		"logout": handleLogout
	};
}

function handleError(event){
	console.log(event);
}

function onRemoteNotificationsRegistered(event){
	var token = event.deviceToken;
	if(Platform.OS === "ios")
		this.handleTokenSuccess("apn2", token);
	else if (Platform.OS === "android")
		this.handleTokenSuccess("fcm", token);
}

function handleTokenSuccess(type, token) {
	AsyncStorage.setItem("PUSH_TOKEN", token).then(function () {
		this.api.push.token.associate(type, token);
	}.bind(this));
}

function notificationReceivedForeground(notification, completion){
	if(Platform.OS === "android") {
		Notifications.postLocalNotification(notification.payload);
	}
	completion({
		alert: false, sound: false, badge: false
	});
}

function notificationReceivedBackground(notification, completion){
	const payload = notification.payload || {};
	const options = {
		alert: true,
		sound: true,
		badge: true
	};

	const type = payload.key1 || payload.type;
	const isNotActiveAndroid = Platform.OS === "android" && AppState.currentState !== "active";

	if(type === "call" || type === 'meeting' && isNotActiveAndroid){
		options.alert = false;
		options.sound = false;
		options.badge = false;
		BackgroundCheckModule.bringApptoForeground();
	}

	if (type === 'meeting' && isNotActiveAndroid) {
		const meeting = payload.key6 || payload.meeting;
		const meetingJson = typeof meeting === 'string' ? JSON.parse(meeting) : meeting;
		this.emit("meetings:new", meetingJson);
	}

	completion(options);
}

function onNotificationOpened(notification, completion) {
	var payload = notification.payload;
	this.handlePayload(payload);
	completion();
}

function handleInitialNotification(notification){


	if(!notification) {
		AsyncStorage.getItem('__PENDING_NOTIFICATION__').then(data => {
			if (data) {
			  const payload = JSON.parse(data);
			  this.handlePayload(payload);
			  AsyncStorage.removeItem('__PENDING_NOTIFICATION__');
			}
			else return;
		  });
	} else {
		var payload = notification.payload;
		this.handlePayload(payload);
	}
}

function handlePayload(payload) {
	if (!payload) return;
	var type = payload.key1 || payload.type;
	var from = payload.key2 || payload.from;

	if (type === "calling") {
		this.emit("callfocuser:trigger:focus");
	} else if (this._callState === null || this._callState === "idle") {
		if (type === "message") {
			this.emit("messages:trigger:open", {
				from: from
			});

			this.emit("atouchawaymessaging:trigger:view:deeplink", {
				who: {
					_id: from
				}
			});
		} else if (type === "groupmessage") {
			const group = { _id: from };

			this.emit("groupchat:trigger:view", { group });

			this.emit("atouchawaymessaging:trigger:view:deeplink", {
				who: group,
				group: true
			});
		} else if (type === "meeting") {
			const meeting = payload.key6 || payload.meeting;
			const meetingJson = typeof meeting === 'string' ? JSON.parse(meeting) : meeting;

			setTimeout(() => {
				this.emit("meetings:new", meetingJson);
			}, 2000);
			
			setTimeout(() => {
				this.emit("callfocuser:trigger:focus");
			}, 2000);
		}
	}
}

function handleLogout() {
	this.clear().then(() => {
		this.emit("logout:trigger:finish", {
			type: "notifications"
		});
	});
}

function handleRefresh(){
	this.clear().then(() => {
		this.emit("refresh:trigger:finish", {
			type: "notifications"
		});
	});
}

function clear(){
	return AsyncStorage.getItem("PUSH_TOKEN").then(function (token) {
		if (!token) return;
		var pushType = getType();
		if(Platform.OS === "ios")
			Notifications.ios.setBadgeCount(0);
		else if(Platform.OS === "android")
			ShortcutBadger.removeCount();
		return this.api.push.token.unassociate(pushType, token);
	}.bind(this)).catch(e => console.error(e));
}

function getType() {
	if(Platform.OS === "ios")
		return "apn2";
	else if (Platform.OS === "android")
		return "fcm";
	return "";
}

function clearBadge() {
	Notifications.ios.setBadgeCount(0);
}

function setCallState(state) {
	this._callState = state;
}